import dynamic from 'next/dynamic';

import useWindowSize from '#app/hooks/useWindowSize';

const Header = dynamic(import('#app/pages/contactanos/layout/header'));
const LayoutContacts = dynamic(import('#app/pages/contactanos/layout'));
const Hero = dynamic(import('#app/pages/contactanos/hero'));
const Preview = dynamic(import('#app/pages/contactanos/preview'));
const Testimonials = dynamic(import('#app/pages/contactanos/testimonials'));
const Banner = dynamic(import('#app/pages/contactanos/banner'));
const RangeMap = dynamic(import('#app/pages/contactanos/range-map'));
const TrustInUs = dynamic(import('#app/pages/contactanos/trust-in-us'));
const Footer = dynamic(import('#app/pages/contactanos/layout/footer'));

const Contactanos = () => {
  const { isDesktop } = useWindowSize();
  return (
    <>
      <div style={{ position: 'relative', width: '100%' }}>
        {isDesktop ? (
          <>
            <Header />
            <LayoutContacts background="white" isCard>
              <Hero />
            </LayoutContacts>
            <LayoutContacts background="#E7F7FF">
              <Preview
                youtubeId="DaxYYPJn7Vk"
                className="pt-56 pb-80 sm_pt-32 sm_pb-40"
              />
              <Testimonials />
            </LayoutContacts>
            <LayoutContacts background="white">
              <Banner />
              <RangeMap />
              <TrustInUs />
            </LayoutContacts>
          </>
        ) : (
          <>
            <LayoutContacts background="white" isCard>
              <Header />
              <LayoutContacts background="white">
                <Hero />
              </LayoutContacts>
              <LayoutContacts background="#E7F7FF">
                <Preview
                  youtubeId="DaxYYPJn7Vk"
                  className="pt-56 pb-80 sm_pt-32 sm_pb-40"
                />
                <Testimonials />
              </LayoutContacts>
              <LayoutContacts background="white">
                <Banner />
                <RangeMap />
                <TrustInUs />
              </LayoutContacts>
            </LayoutContacts>
          </>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Contactanos;
